type ProgressRailProps = {
  current: number;
  total: number;
  label?: string;
  variant?: "bar" | "capsules";
  showSessionMarker?: boolean;
  sessionMarkerComplete?: boolean;
  valueLabel?: string;
};

export function ProgressRail({
  current,
  total,
  label = "本部分",
  variant = "bar",
  showSessionMarker,
  sessionMarkerComplete,
  valueLabel
}: ProgressRailProps) {
  const safeTotal = Math.max(total, 1);
  const safeCurrent = Math.min(Math.max(current, 0), safeTotal);
  const nodes = Array.from({ length: safeTotal }, (_, index) => index + 1);
  const displayValue = valueLabel ?? `${safeCurrent} / ${safeTotal}`;

  return (
    <section className="progress-strip" aria-label={`${label}进度 ${safeCurrent} / ${safeTotal}`}>
      <div className="progress-label">
        <span>{label}</span>
        <span>{displayValue}</span>
      </div>
      {variant === "capsules" ? (
        <div className="progress-capsule-row" aria-hidden="true">
          {showSessionMarker ? (
            <span className={`session-capsule${sessionMarkerComplete ? " complete" : ""}`} />
          ) : null}
          <ol
            className="progress-capsules"
            style={{ gridTemplateColumns: `repeat(${safeTotal}, minmax(18px, 1fr))` }}
          >
            {nodes.map((node) => (
              <li
                key={node}
                className={[
                  node < safeCurrent ? "complete" : "",
                  node === safeCurrent ? "current" : ""
                ]
                  .filter(Boolean)
                  .join(" ")}
              />
            ))}
          </ol>
        </div>
      ) : (
        <div className="progress-rail">
          <div style={{ width: `${(safeCurrent / safeTotal) * 100}%` }} />
        </div>
      )}
    </section>
  );
}
